export function projectEntryState(projects: ReadonlyArray<{ id: string }>, selectedId: string): "ready" | "choose" | "create" {
  if (!projects.length) return "create";
  return selectedId && projects.some((project) => project.id === selectedId) ? "ready" : "choose";
}
